import React from 'react';

interface TbcErrorBannerProps {
    error: string | null;
    onDismiss?: () => void;
}

const TbcErrorBanner: React.FC<TbcErrorBannerProps> = ({ error, onDismiss }) => {
    if (!error) {
        return null;
    }

    return (
        <div className="error-message" style={{ marginBottom: '16px' }}>
            <p style={{ margin: onDismiss ? '0 0 12px 0' : 0 }}>{error}</p>
            {onDismiss && (
                <button type="button" onClick={onDismiss} className="clear-button">
                    Dismiss
                </button>
            )}
        </div>
    );
};

export default TbcErrorBanner;
